// extracted by mini-css-extract-plugin
export default {"Container":"EditableUserInfo_Container__0lESt","Button":"EditableUserInfo_Button__INBkh","Save":"EditableUserInfo_Save__SkqXa","Delete":"EditableUserInfo_Delete__pyKgX"};